import { render, staticRenderFns } from "./Recibo.vue?vue&type=template&id=1ab9d34b&scoped=true&lang=pug&"
import script from "./Recibo.vue?vue&type=script&lang=js&"
export * from "./Recibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab9d34b",
  null
  
)

export default component.exports